import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Phone, Mail } from 'lucide-react'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const navItems = [
    { name: 'Forside', path: '/' },
    { name: 'Udlejning af entreprenørmaskiner', path: '/udlejning' },
    { name: 'Udlejning af værktøj', path: '/vaerktojsudlejning' },
    { name: 'Kontakt os', path: '/kontakt' }
  ]

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-neutral-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/6fc95741-bbf3-49e6-9c69-766b0204a25f.png"
                alt="D&W Udlejning ApS Logo"
                className="h-14 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop Navigation (Visible at >= 1200px) */}
          <nav className="hidden min-[1200px]:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-bold tracking-wide uppercase transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'text-amber-600 border-b-2 border-amber-500 pb-1'
                    : 'text-neutral-600 hover:text-neutral-900'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA (Visible at >= 1200px) */}
          <div className="hidden min-[1200px]:flex items-center gap-4">
            <a
              href="tel:20828970"
              className="flex items-center gap-2 text-sm font-bold text-neutral-700 bg-neutral-100 hover:bg-neutral-200 border border-neutral-200 px-4 h-11 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              <Phone className="w-4 h-4 text-amber-600" />
              <span>20 82 89 70</span>
            </a>
            <Link
              to="/kontakt"
              className="flex items-center justify-center text-sm font-bold text-neutral-950 bg-amber-500 hover:bg-amber-400 px-5 h-11 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              Lej maskine nu
            </Link>
          </div>

          {/* Mobile Menu Button (Visible at < 1200px) */}
          <div className="flex min-[1200px]:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Åbn menu</span>
              {isOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu (Visible at < 1200px) */}
      {isOpen && (
        <div className="min-[1200px]:hidden bg-white border-b border-neutral-200" id="mobile-menu">
          <div className="px-2 pt-2 pb-4 space-y-1 sm:px-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-3 rounded-md text-base font-bold tracking-wide uppercase ${
                  isActive(item.path)
                    ? 'bg-amber-50 text-amber-600 border-l-4 border-amber-500'
                    : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 pb-2 border-t border-neutral-200 px-3 space-y-3">
              <a
                href="tel:20828970"
                className="flex items-center gap-3 text-base font-bold text-neutral-700 bg-neutral-100 border border-neutral-200 py-3 px-4 rounded-md"
              >
                <Phone className="w-5 h-5 text-amber-600" />
                <span>Ring: 20 82 89 70</span>
              </a>
              <a
                href="mailto:dw@dw-udlejning.dk"
                className="flex items-center gap-3 text-base font-bold text-neutral-700 bg-neutral-100 border border-neutral-200 py-3 px-4 rounded-md"
              >
                <Mail className="w-5 h-5 text-amber-600" />
                <span className="truncate">dw@dw-udlejning.dk</span>
              </a>
              <Link
                to="/kontakt"
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-center text-base font-bold text-neutral-950 bg-amber-500 hover:bg-amber-400 py-3 px-4 rounded-md"
              >
                Kontakt os for udlejning
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
